import { useState, useEffect } from 'react'
import { useScopedSetUserInput } from './use-scoped-user-input'

export const useSelectionInput = () => {
  const setUserInput = useScopedSetUserInput()
  const [selectionInputVisible, setSelectionInputVisible] = useState(false)
  const [selectionPosition, setSelectionPosition] = useState({ x: 0, y: 0 })
  const [selectedText, setSelectedText] = useState('')

  useEffect(() => {
    const handleSelection = () => {
      const selection = window.getSelection()
      if (selection && selection.toString().trim() && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0)
        const rect = range.getBoundingClientRect()
        // Suppress when selection is inside Tiptap editor or non-editable area
        let container: Node | null = range.commonAncestorContainer
        let el: HTMLElement | null =
          (container as any).nodeType === Node.ELEMENT_NODE
            ? (container as HTMLElement)
            : (container as any)?.parentElement || null
        let insideEditor = false
        while (el) {
          const cls = (el.className || '').toString()
          if (cls.includes('ProseMirror') || el.getAttribute?.('contenteditable') === 'true') {
            insideEditor = true
            break
          }
          el = el.parentElement
        }
        if (insideEditor) {
          setSelectionInputVisible(false)
          return
        }

        setSelectedText(selection.toString().trim())
        setSelectionPosition({
          x: rect.left + rect.width / 2,
          y: rect.top - 10 // Position above the selection
        })
        setSelectionInputVisible(true)
      } else {
        setSelectionInputVisible(false)
      }
    }

    document.addEventListener('mouseup', handleSelection)
    document.addEventListener('keyup', handleSelection)

    return () => {
      document.removeEventListener('mouseup', handleSelection)
      document.removeEventListener('keyup', handleSelection)
    }
  }, [])

  const handleSelectionSubmit = () => {
    if (selectedText) {
      setUserInput(
        `Regarding this text: "${selectedText}"\n\nCan you explain this or help me understand it better?`
      )
      setSelectionInputVisible(false)
      setSelectedText('')
    }
  }

  return {
    selectionInputVisible,
    selectionPosition,
    selectedText,
    handleSelectionSubmit
  }
}
